<template>
    <div 
        class="base-item-picker d-flex justify-content-between align-items-stretch"
    >
        <div
            v-for="option in options" 
            :key="option[valueField]"
            @click="handleSelection(option[valueField])" 
            class="px-3 py-2 item-picker-element border rounded"
            :class="[option[valueField] === value ? 'shadow selected' : 'shadow-sm', equalWidth ? 'equal-width' : '']"
        >
            <div class="d-flex justify-content-between align-items-start">
                <h6>{{ option[titleField] }}</h6>
                <transition name="fade-fast" mode="out-in">
                    <b-spinner 
                        v-if="loading"
                        key="loadingspinner"
                        small
                    ></b-spinner>
                    <b-icon 
                        v-else-if="value === option[valueField]" 
                        key="checkedIcon"
                        icon="check" 
                        variant="white"
                        class="bg-success m-0 rounded-circle"
                        style="height: 16px; width: 16px;"
                    ></b-icon>
                </transition>
            </div>
            <p class="text-muted small mb-0">{{ option[textField] }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseItemPicker',
    props: {
        value: [String, Number, Boolean],  // supports v-model
        options: {
            type: Array,
            required: true,
        },
        valueField: {
            type: String,
            default: 'value',
        },
        titleField: {
            type: String,
            default: 'title',
        },
        textField: {
            type: String,
            default: 'text',
        },
        flexFill: {  // puts .flex-fill on each child to take up space
            type: Boolean,
            defaut: false,
        },
        equalWidth: {  // sets picker boxes to be equal width
            type: Boolean,
            default: false,
        },
        disabled: {  // if true, will not respond to user input, just blocks $emit of input event, which won't update v-model
            type: Boolean,
            default: false,
        },
        loading: {  // loading flag, when loading it will be disabled from handling clicks, and will show loading state
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            //selection: null,   
        }
    },
    computed: {
    },
    methods: {
        handleSelection: function(value) {
            //this.selection = value;
            if (!this.disabled && !this.loading) this.$emit('input', value);
        }
    }
}
</script>

<style scoped>
    .item-picker-element.equal-width {
        flex: 1 1 0px;
    }
    .item-picker-element {
        cursor: pointer;
        transition: 0.15s ease-in-out;
        margin-right: 1rem;
    }
    .item-picker-element:last-child {
        margin-right: 0;
    }
    .item-picker-element:not(.selected) {
        background-color: var(--gray-100);
    }
    .item-picker-element.selected {
        background-color: #fff;
        border-color: var(--success) !important;
    }
</style>